
<div class="listing-section" *ngFor="let pr of productList">
  <app-product *ngFor="let p of pr.items" [displayReviewStatus]="displayReviewStatus" [product]="p" [isEditable]="!readOnly" [isForGiveAway]="pr.is_for_giveaway" (click)='clicked(p)' [class.selected]="isSelected(p)">
  </app-product>
</div>  